import {Icon} from '@atoms';
import {Button} from '@molecules';
import {useTranslation} from 'react-i18next';
import {animated, useSpring} from '@react-spring/web';
import {cn} from '@utils';

type Props = {
  handleDismiss: () => void;
  title: string;
  content: string;
  link?: string;
  mobile?: boolean;
};

let hasAnimated = false;

export const EmployeeCommunicationAnnouncement = ({handleDismiss, title, content, link, mobile}: Props) => {
  const {t} = useTranslation();

  const springProps = useSpring({
    from: hasAnimated ? {opacity: 1, transform: 'scale(1)'} : {opacity: 0, transform: 'scale(0.9)'},
    to: {opacity: 1, transform: 'scale(1)'},
    config: {tension: 180, friction: 20},
    onRest: () => {
      hasAnimated = true;
    },
  });

  return (
    <animated.div
      {...springProps}
      className={cn('bg-safe-mauve-500* p-6 gap-4 ', {
        'hidden lg:grid rounded-lg+': !mobile,
        'grid lg:hidden sm:rounded-lg+': mobile,
      })}>
      <div className="bg-white/15 size-10 rounded-lg flex items-center justify-center">
        <Icon
          className="size-6"
          color="white"
          size="default"
          icon="megaPhone"
        />
      </div>

      <div className="flex flex-col text-white gap-2.5">
        <span>
          <h3 className="text-white leading-none">{title}</h3>
          <p>{content}</p>
        </span>

        <div className="flex gap-2.5">
          {link && (
            <Button
              as="a"
              /** @ts-expect-error */
              href={link}
              target="_blank"
              size="small"
              button={'primary light'}
              iconRight="openInBrowser">
              {t('moreInfo')}
            </Button>
          )}
          <Button
            size="small"
            button={'tertiary light'}
            onClick={handleDismiss}>
            {t('dismiss')}
          </Button>
        </div>
      </div>
    </animated.div>
  );
};
